'use client';

import { useMemo } from 'react';
import Link from 'next/link';
import { Twitter, Facebook, Instagram } from 'lucide-react';
import { getHostNavLinks } from "../assets/routes"
import { useHostSiteLinkBase } from '../HostSiteLinkBase'
import whiteLogoImage from '../assets/white-logo.png';
import Image from 'next/image';

const DiscordIcon = ({ size = 24 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.419 0 1.334-.956 2.419-2.157 2.419zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.419 0 1.334-.946 2.419-2.157 2.419z" />
  </svg>
);

export default function Footer() {
  const linkBase = useHostSiteLinkBase();
  const navLinks = useMemo(() => getHostNavLinks(linkBase), [linkBase]);

  return (
    <footer className="border-t border-zinc-800 bg-[#0f0f0f] py-12 px-6 md:px-12 lg:px-24">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 md:flex-row">
        
        <div className="flex flex-col items-center gap-2 md:items-start">
          <Link href={linkBase} className="text-xl font-black tracking-tighter text-[#b4ff00]">
               <Image
                                 src={whiteLogoImage}
                                 alt="Disporty"
                                 className="object-contain w-auto h-[50px]"
                               />
          </Link>
          <p className="text-xs text-zinc-500">
            © 2026 Disporty. The Elite Broadcast Standard.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-xs font-medium text-zinc-400">
          {navLinks.map((link,index) => (
            <Link key={index} href={link.href} className="hover:text-white transition-colors">{link.name}</Link>
          ))}
        </div>

        <div className="flex items-center gap-4 text-zinc-500">
          <Link href="#" aria-label="Facebook" className="hover:text-white transition-colors">
            <Facebook size={18} />
          </Link>
          <Link href="#" aria-label="Instagram" className="hover:text-white transition-colors">
            <Instagram size={18} />
          </Link>
          <Link href="#" aria-label="Twitter" className="hover:text-white transition-colors">
            <Twitter size={18} />
          </Link>
          <Link href="#" aria-label="Discord" className="hover:text-white transition-colors">
            <DiscordIcon size={18} />
          </Link>
        </div>

      </div>
    </footer>
  );
}

